import React, { forwardRef } from "react";
import styles from "./styles/InputTextArea.module.css";
import { capitalizeFirstLetter } from "../../../utils/utils";
/**
 * Inpur text component
 * ForwardRef is used to focus on the element when mounted since it is a component
 */
const InputTextArea = forwardRef(
    (
        {
            label,
            inputId,
            inputValue,
            handleChangeFunction,
            required,
            rows = 4,
            cols = 50,
            placeholder,
            letterSpacing,
            textAlign,

            data,
            disable,
            fullWidth,
            readOnly,
        },
        ref
    ) => {
        return (
            <div
                className={`${styles.input_container} ${
                    fullWidth ? styles.full_width : ""
                } v-flex-container`}
            >
                <label className={`${styles.input_label}`} htmlFor={inputId}>
                    {label}
                    {label ? ":" : ""}
                </label>
                <textarea
                    readOnly={readOnly}
                    ref={ref}
                    data-ex={data && data}
                    className={`${styles.input_element} ${
                        required && styles.alert
                    } ${disable ? styles.disabled : ""}  `}
                    style={{
                        letterSpacing: letterSpacing,
                        textAlign: textAlign,
                    }}
                    name={inputId}
                    id={inputId}
                    rows={rows}
                    cols={cols}
                    value={inputValue ?? ""}
                    placeholder={
                        required ? capitalizeFirstLetter(placeholder) : ""
                    }
                    onChange={handleChangeFunction}
                    spellCheck={false}
                    autoComplete={"off"}
                    disabled={disable}
                />
            </div>
        );
    }
);

export default InputTextArea;
